//账单

export default [
    {   //库存异动单客户端
        path: "warehouse/moveclient",
        name: "warehouseMoveClient",
        component: () => import(/* webpackChunkName: "warehousemove" */ "@/views/warehouse/moveclient/index"),
    },
    {   //销毁计划编辑
        path: "warehouse/move/detail/:type",
        name: "moveDetail",
        component: () => import(/* webpackChunkName: "warehousemove" */ "@/views/warehouse/moveclient/detail.vue"),
    },
    {   //库存异动单管理端
        path: "warehouse/movemanage",
        name: "warehouseMoveManage",
        component: () => import(/* webpackChunkName: "warehousemove" */ "@/views/warehouse/movemanage/index"),
    }
]


